export default {
    trial: 'trial',
    options() {
        return [this.trial]
    }

}